module.exports = __webpack_public_path__ + "img/footprints.df818980.png";